import { render } from "./ProjectThumbnail.vue?vue&type=template&id=c07dce38&scoped=true"
import script from "./ProjectThumbnail.vue?vue&type=script&lang=js"
export * from "./ProjectThumbnail.vue?vue&type=script&lang=js"

import "./ProjectThumbnail.vue?vue&type=style&index=0&id=c07dce38&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c07dce38"]])

export default __exports__